import React, { useState, useRef } from "react";
import {
  TextField,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@material-ui/core";
import Nationality from "./Nationality";
import TelePhoneCompany from "./TeleCompany";
import CertificationNumberSend from "./CertitificationNumberSend";
import JeonMoonAll from "./JeonMoonAll";
import JeonMoon1 from "./JeonMoon1";
import JeonMoon2 from "./JeonMoon2";
import JeonMoon3 from "./JeonMoon3";
import JeonMoon4 from "./JeonMoon4";



function SelfCertification(props) {
  const {name, partDiv , partNo,birthday, phone,step, phoneValid, gender,InOutGb,selfCertiStep,TeleCompanyCode,CertiInput, CertificatoinId ,onChangeCertiInput,onChangeCertificationID,onChangeInOutGb, onChanTeleCompany,onIncrementCertifistep,useStyles,url ,onChangeSelfCertification} = props;
   
    return (
        <>
        
            <Nationality onChangeInOutGb={onChangeInOutGb} InOutGb={InOutGb} useStyles={useStyles} SelfCertification={props.SelfCertification}/>
            <TelePhoneCompany TeleCompanyCode={TeleCompanyCode} onChanTeleCompany={onChanTeleCompany} useStyles={useStyles} SelfCertification={props.SelfCertification}/>
            <JeonMoonAll useStyles={useStyles} JeonMoonAll={props.JeonMoonAll} onChangeJeonMoonAllYn={props.onChangeJeonMoonAllYn} SelfCertification={props.SelfCertification}/>
            <JeonMoon1 useStyles={useStyles} JeonMoon1={props.JeonMoon1} onChangeJeonMoon1Yn={props.onChangeJeonMoon1Yn} SelfCertification={props.SelfCertification}/>
            <JeonMoon2 useStyles={useStyles} JeonMoon2={props.JeonMoon2} onChangeJeonMoon2Yn={props.onChangeJeonMoon2Yn} SelfCertification={props.SelfCertification}/>
            <JeonMoon3 useStyles={useStyles} JeonMoon3={props.JeonMoon3} onChangeJeonMoon3Yn={props.onChangeJeonMoon3Yn} SelfCertification={props.SelfCertification}/>
            <JeonMoon4 useStyles={useStyles} JeonMoon4={props.JeonMoon4} onChangeJeonMoon4Yn={props.onChangeJeonMoon4Yn} SelfCertification={props.SelfCertification}/>

            <CertificationNumberSend phoneValid={phoneValid} phone={phone} step={step} gender={gender} InOutGb={InOutGb} selfCertiStep={selfCertiStep}
                                     TeleCompanyCode={TeleCompanyCode} onIncrementCertifistep={onIncrementCertifistep} url={url} onChangeCertificationID={onChangeCertificationID}
                                     CertificatoinId={CertificatoinId} useStyles={useStyles} CertiInput={CertiInput} onChangeCertiInput={onChangeCertiInput}
                                     name={name} partDiv={partDiv} partNo={partNo} birthday={birthday} onChangeSelfCertification={onChangeSelfCertification}
                                     JeonMoon1={props.JeonMoon1} JeonMoon2={props.JeonMoon2} JeonMoon3={props.JeonMoon3} JeonMoon4={props.JeonMoon4} 
                                     SelfCertification={props.SelfCertification}
             />   
        </>
      );
}

export default SelfCertification;





